import { Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { DealerDetailsListViewModel } from '../../business-entities/dealer-details-view-model';
import { DealerRequestModel, DealerViewModel } from '../../business-entities/dealer-view-model';
import { StatusViewModel } from '../../business-entities/status-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { DashboardService } from '../../business-services/dashboard.service';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { NgbdModalContent } from './../../../../../Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from './../../../../../Autofacets-Core/src/app/utils/constant';
import { DealerListViewModel } from './../../business-entities/dealer-list-view-model';
import { AddDealerComponent } from './add-dealer/add-dealer.component';
import { GetDmsDealerComponent } from './get-dms-dealer/get-dms-dealer.component';
import { EditDealerComponent } from './edit-dealer/edit-dealer.component';
import { Features } from '../../business-entities/user-role-view-model';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { DMSSyncFailedlogService } from '../../business-services/dms-sync-failed-log.service';
import { DMSSyncFailedLogRequestModel } from '../../business-entities/dmssyncfailedlog-request-model';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { Subscription } from 'rxjs';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';

@Component({
  selector: 'app-dealer',
  templateUrl: './dealer.component.html',
})
export class DealerComponent implements OnInit, OnDestroy {
  dealerList: DealerListViewModel[] = [];
  popupCloseResult = false;
  lblYes = 'true';
  lblNot = 'false';
  userRoleRightsDetails: UserRoleMenu;
  dealerDetailsListViewModel: DealerDetailsListViewModel;
  dealerDetails: DealerViewModel;
  searchTerm = '';
  throttle = 100;
  scrollDistance = 1;
  totalCount: number = 0;
  dealerRequestModel:DealerRequestModel = {
    statusId: 0,
    keyLocation:false,
    onlinePayment:false,
    isAdvanceSearch:false,
    isAllDealer:true,
    startRecordNumber: 0,
    PageSize: 25,
    SortColumn: 'Name',
    sortDirection: 'DESC',
    searchTerm: '',
    isForList: true
  };
  dealerListExcel: any;
  dealerListPdf: any;
  isAdvanceSearch: boolean = false;
  filteredDealerlist: DealerViewModel[] = [];//Created this variable for advance search
  StatusList: StatusViewModel[] = [];
  selectedStatus: number;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  features: Features[] = [];
  isShareBoxEnabled :boolean = false;
  isShowLocationCode : boolean = false;
  isOLB : boolean = false;
  subscription : Subscription;
  dmsLogRequestModel: DMSSyncFailedLogRequestModel =
    {
      startRecordNumber: 0,
      pageSize: 25,
      sortColumn: '',
      sortDirection: '',
      moduleId: Enums.ModuleNames.DealerDetails,
      logDate: '',
      referenceId: 0,
      referenceName: ''
    };
  constructor(
    public dealerBusinessService: DealerBusinessService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private userService: UserDataService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private excelService: ExcelService,
    config: NgbModalConfig,
    private dashboardService: DashboardService,
    private currentLanguageService: CurrentLanguage,
    private secureStorage: SecureStorage,
    private _eref: ElementRef,
    private dmsService: DMSSyncFailedlogService
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  async ngOnInit() {
    this.isShowLocationCode = localStorage.getItem("Theme") === 'bnh';

    if (this.dashboardService.isFromDashboard) {
      this.selectedStatus = Enums.StatusCode.Active;
    }

    if (this.selectedStatus != undefined) {
      this.dealerRequestModel.statusId = this.selectedStatus;
    }
    this.StatusList = this.dashboardService.getStatusList();
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.DealerDetails);

    this.dealerList = [];
    this.filteredDealerlist = [];
    this.dealerRequestModel.startRecordNumber = 0;

    this.getDealerList(this.dealerRequestModel);
    await this.getFeatures();
  }
  async getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
    if (this.features == null || this.features == undefined) {
      this.subscription = this.currentLanguageService.featureList.subscribe((res) => {
        this.features = res;
        if (this.features?.length > 0) {
          this.setFetureData();
        }
      })
    }
    else {
      this.setFetureData();
    }
  }

  setFetureData() {
    this.isShareBoxEnabled = this.features.find(x => x.featureCode === Enums.FeatureCode.ShareBox)?.isActive;
    this.isOLB = this.features.find(x => x.featureCode === Enums.FeatureCode.OLB)?.isActive;
  }
  ngOnDestroy(): void {
    this.dashboardService.isFromDashboard = false;
  }
  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event && event.target.className.indexOf('ng-option')== -1) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
        this.dealerRequestModel.isAdvanceSearch = false;
      }
    }
  }
  StatusChange(status: any,isFromAdvanceSearch: boolean) {
    if (status == undefined) {
      this.dealerRequestModel.statusId = Enums.StatusCode.All;
    } else {
      this.dealerRequestModel.statusId = status;
    }
    if(isFromAdvanceSearch === false){
      this.dealerList = [];
      this.filteredDealerlist = [];
      this.dealerRequestModel.startRecordNumber = 0;
      this.getDealerList(this.dealerRequestModel);
    }
  }

  async onSearchFilter(){
    this.dealerRequestModel.startRecordNumber = 0;
    this.dealerList = [];
    this.filteredDealerlist = [];
    try{
      await this.getDealerList(this.dealerRequestModel);
    }
    catch{
      this.spinner.hide();
    }
  }
  onScrollDown(_ev) {
    if(this.totalCount > this.dealerList.length){
      this.dealerRequestModel.startRecordNumber = this.dealerList.length
      this.getDealerList(this.dealerRequestModel);
    }
  }

  async getDealerList(dealerRequestModel: DealerRequestModel) {
    this.spinner.show();
    await this.dealerBusinessService.getDealerList(dealerRequestModel).then((response) => {
      this.totalCount = 0;
      this.filteredDealerlist.push(...response);
      this.dealerList.push(...this.dealerDataMapper(response))
      if(this.dealerList.length > 0)
        this.totalCount = this.dealerList[0].totalCount;
      this.spinner.hide();
    });
  }

  private dealerDataMapper(dealers: DealerViewModel[]) {
    return dealers.map((dealer, i) => {
      return {
        row: i + 1,
        dealerId: dealer.dealerId,
        name: dealer.name,
        address: `${dealer.address1 ? dealer.address1.trim() + ', ' : ''}${dealer.address2 ? dealer.address2.trim() + ', ' : ''}${dealer.city ? dealer.city.trim() + ', ' : ''}${dealer.state ? dealer.state.trim() + ', ' : ''}${dealer.country ? dealer.country.trim() + ', ' : ''}${dealer.pincode ? dealer.pincode.trim() : ''}`,
        landlineCode: dealer.landlineCode ? dealer.landlineCode.toString() : '',
        landline: dealer.landline ? dealer.landline.toString() : '',
        mobile: dealer.mobile ? dealer.mobile.toString() : '',
        mobileCode: dealer.mobileCode ? dealer.mobileCode.toString() : '',
        email: dealer.email,
        isActive: dealer.isActive ? this.lblYes : this.lblNot,
        keyLocation: dealer.keyLocation ? this.lblYes : this.lblNot,
        onlinePayment: dealer.onlinePayment ? this.lblYes : this.lblNot,
        dealershipsId: dealer.dealershipsId,
        franchiseId: dealer.franchiseId,
        locationCode:dealer.locationCode,
        totalCount:dealer.totalCount,
        dmsSyncDate:dealer.dmsSyncDate,
        dmsSyncStatus:dealer.dmsSyncStatus,
        dealerDmsNo:dealer.dealerDmsNo
      } as DealerListViewModel
    });
  }

  private dealerExcelDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.No = index + 1;
        single.DealerName = element.name;
        single.Address = `${element.address1 ? element.address1.trim() + ', ' : ''}${element.address2 ? element.address2.trim() + ', ' : ''}${element.city ? element.city.trim() + ', ' : ''}${element.state ? element.state.trim() + ', ' : ''}${element.country ? element.country.trim() + ', ' : ''}${element.pincode ? element.pincode.trim() : ''}`;
        single.Landline = (element.landlineCode ? '+' + element.landlineCode : '') + (element.landline ? '-' + element.landline : '');
        single.Mobile = (element.mobileCode ? '+' + element.mobileCode : '') + (element.mobile ? '-' + element.mobile : '');
        single.Email = element.email;
        single.ActiveStatus = element.isActive ? 'Active' : 'InActive';
        single.KeyLocation = element.keyLocation ? 'Yes' : 'No';
        single.OnlinePayment = element.onlinePayment ? 'Yes' : 'No';
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  onAdd() {
    if(localStorage.getItem('Theme') == 'mg')
    {
      const modalref = this.modalService.open(GetDmsDealerComponent, { size: 'lg', windowClass: 'pop-wid1366 CustomCardPopup', backdrop: 'static' });
      modalref.result.then((response) => {
        if (response.success) {
          const modalAddref = this.modalService.open(AddDealerComponent, { size: 'lg', windowClass: 'EditPopup' });
          modalAddref.componentInstance.olbDealer = response.dealer;
          modalAddref.result.then((response) => {
            if (response.success) {
              this.ngOnInit();
            }
          });
        }
      });
    }
    else {
      const modalref = this.modalService.open(AddDealerComponent, { size: 'lg', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      }, _error => {
        // This is intentional
        });
    }
  }

  editDealer(dealerId: string) {
    this.dealerBusinessService.dealerId = dealerId;
    const modalref = this.modalService.open(EditDealerComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    }, _error => {
      // This is intentional
     });
  }

  deleteDealer(id: string) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblDealers"),true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.dealerBusinessService.deleteDealer(id).then((response) => {
          if (response.responseCode === Constant.SuccessResponseCode) {
            if (response.responseObject === Constant.DeleteDealerFail) {
              let msg = this.translate.instant('lblDealerDeleteError')
              this.toaster.error(msg);
            }
            else if (response.responseObject === Constant.DealerAssociationFound) {
              let msg = this.translate.instant('lblDealerAssociationWarningMessage');
              this.toaster.error(msg);
            }
            else {
              let successMsg = this.translate.instant('lblDealerDeleteSuccess')
              this.toaster.success(successMsg);
              this.dealerList = [];
              this.filteredDealerlist = [];
              this.dealerRequestModel.startRecordNumber = 0;
              this.getDealerList(this.dealerRequestModel);
            }
          }
        });
      }
    });
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.dealerList = [];
    this.filteredDealerlist = [];
    this.dealerRequestModel.startRecordNumber = 0;
    this.dealerRequestModel.SortColumn = column;
    this.dealerRequestModel.sortDirection = direction;
    this.getDealerList(this.dealerRequestModel);
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  public get documentTypes(): typeof Enums.DocumentsType {
    return Enums.DocumentsType;
  }

  public async exportAsXLSX(_excel: number) {
    this.spinner.show();
    this.dealerListExcel = this.dealerExcelDataMapper(this.filteredDealerlist);
    this.spinner.hide();
    this.excelService.exportAsExcelFile(this.dealerListExcel, 'dealers_af');
  }

  public async onDownloadPDF(_pdf: number) {
    this.spinner.show();
    this.dealerListPdf = this.dealerDataMapper(this.filteredDealerlist);

    setTimeout(() => {
      const doc = new jsPDF();
      autoTable(doc, { html: '#dealerPdf', margin: { top: 3, left: 3, right: 3, bottom: 3 }, styles: { fontSize: 8 } });
      doc.save('Dealer-List.pdf');
      this.spinner.hide();
    }, 100)
  }

  onAdvanceSearch() {
    this.dealerRequestModel.isAdvanceSearch = true;
  }

  onReset() {
    this.dealerRequestModel.isAdvanceSearch = false;
    this.dealerRequestModel.keyLocation = false;
    this.dealerRequestModel.onlinePayment = false;
    this.selectedStatus = undefined;
    this.dealerRequestModel.statusId = Enums.StatusCode.All;
    this.dealerList = [];
    this.filteredDealerlist = [];
    this.dealerRequestModel.startRecordNumber = 0;
    this.getDealerList(this.dealerRequestModel);
  }

  onClose() {
    this.dealerRequestModel.isAdvanceSearch = false;
  }

  AdvanceSearchSubmit() {
    this.dealerRequestModel.isAdvanceSearch = true;
    this.dealerList = [];
    this.filteredDealerlist = [];
    this.dealerRequestModel.startRecordNumber = 0;
    this.getDealerList(this.dealerRequestModel);
    this.dealerRequestModel.isAdvanceSearch = false;
  }

  onSyncToDms(dealerId) {
    let modelHeadermsg = this.translate.instant("lblSyncToOLB");
    let modelBodymsg = this.translate.instant("lblSureToSyncOLB");
    let errorMsg = this.translate.instant('lblErrormsg');
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);
      if (this.popupCloseResult) {
        this.spinner.show();
        this.dealerBusinessService.ResyncDealer(dealerId).then((response) => {
          this.spinner.hide();
          if (response.responseObject) {
            let successMsg = this.translate.instant('lblSyncSuccessOLB')
            this.toaster.success(successMsg);
            this.dealerList = [];
            this.filteredDealerlist = [];
            this.dealerRequestModel.startRecordNumber = 0;
            this.getDealerList(this.dealerRequestModel);
          } else {
            this.spinner.hide();
            this.toaster.error(errorMsg);
          }
        });
      }
    });
  }

  viewException(dealerDmsNo: string) {
    this.dmsLogRequestModel.referenceName = dealerDmsNo;
    this.spinner.show();
    let errorMsg = this.translate.instant('lblNoErrorDetails');
    this.dmsService.GetDmsSyncFailedLog(this.dmsLogRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.spinner.hide();
        if (response.responseObject.length > 0) {
          let ex = response.responseObject[0].exceptionMessage;

          let modelHeadermsg = this.translate.instant("lblException");
          const modalRef = this.modalService.open(NgInfoModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = ex;
          modalRef.result.then((_result) => {
            // This is intentional
          }, (reason) => {
            this.popupCloseResult = this.getDismissDeleteReason(reason);
          });
        } else {
          this.toaster.error(errorMsg);
        }
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.MechanicCode) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }

  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
}

